<template>
  <v-list two-line>
    <div v-for="(ticket, index) in list" :key="'ticket_'+index">
      <v-divider
          v-if="index > 0"
          :key="'ticket_line_'+index"
          inset
      ></v-divider>
      <v-list-item
          dense
          :key="'ticket_item_'+index"
          :style="ticket.status === 1 ? 'background-color: rgb(255,235,59, 0.25)' : ''"
          :to="{name: 'ticket', params: {id: ticket.uid}}"
          exact
      >
        <v-list-item-avatar
            color="blue-grey lighten-4"
        >
          <v-icon v-if="ticket.comment.my === 'yes'" color="white">mdi-account</v-icon>
          <template v-else>
            <img
                v-if="ticket.comment.avatar !== ''"
                :src="ticket.comment.avatar"
            >
            <v-icon v-else color="white">mdi-account</v-icon>
          </template>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title :class="ticket.status === 1 ? 'font-weight-black' : ''"
                             v-html="ticket.name"
          />
          <v-list-item-subtitle :class="ticket.status === 1 ? 'font-weight-bold' : ''"
                                v-text="escape(ticket.comment.message)"
          />
          <v-list-item-subtitle>
            <div>
              <span class="font-weight-light">№ запроса: {{ ticket.id }} | Создано: {{ getDate(ticket.created) }} | Обновлено: {{ getDate(ticket.updated) }} | </span>
              <span :class="!ticket.deadline ? 'font-weight-light' : 'font-weight-light warning--text'" v-text="!ticket.deadline ? 'Без дедлайна' : 'Дедлайн до ' + getDate(ticket.deadline)"/>
            </div>
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <div>
            <v-tooltip left v-if="ticket.priority === 3 && ticket.status !== 2">
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="thunderbird" v-bind="attrs" v-on="on">mdi-fire</v-icon>
              </template>
              <span>Высокий приоритет</span>
            </v-tooltip>
            <v-chip
                x-small
                :color="ticket.status === 0 ? '' : ticket.status === 1 ? 'warning' : ticket.status === 2 ? 'success' : 'info'"
                v-text="ticket.status === 0 ? 'В работе' : ticket.status === 1 ? 'На проверке' : ticket.status === 2 ? 'Закрыт' : 'На уточнении'"
                class="ml-3"
            />
          </div>
        </v-list-item-action>
      </v-list-item>
    </div>
  </v-list>
</template>

<script>
export default {
  name: 'Tickets',
  props: ['list', 'count', 'sort'],
  data: () => ({

  }),
  watch: {
    '$store.state.sorting.status': function () {
      this.emitSorting()
    },
    '$store.state.sorting.priority': function () {
      this.emitSortingPriority()
    },
  },
  methods: {
    escape(str) {
      str=str.replace(/<br>/gi, "\n");
      str=str.replace(/<p.*>/gi, "\n");
      str=str.replace(/<a.*href="(.*?)".*>(.*?)<\/a>/gi, " $2 (Link->$1) ");
      str=str.replace(/<(?:.|\s)*?>/g, "");
      return str;
    },
    emitSorting() {
      this.$emit('sort-event')
    },
    emitSortingPriority() {
      this.$emit('sort-priority-event')
    },
    getDate(unix) {
      let date = new Date(unix * 1000);
      let hours = date.getHours();
      let minutes = "0" + date.getMinutes();
      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      if (day < 10) {
        day = '0' + day;
      }
      if (month < 10) {
        month = '0' + month;
      }
      let formattedTime = hours + ':' + minutes.substr(-2);
      let formattedDate = day + '-' + month + '-' + year;
      return formattedDate + ' ' + formattedTime;
    },
  }
}
</script>